import { useLanguageFromQuery } from '../../hooks/useLanguageFromQuery';

export const LanguageInitializer = ({ children }: { children: React.ReactNode }) => {
  useLanguageFromQuery();
  return <>{children}</>;
};
